import React, { Component, Fragment } from 'react';
import AutoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import Moment from 'Moment';
import Modal from '../../util/modal';
import { FormGroup } from '../../util/form-group';

import { Factura_Contado_Individual, Factura_Credito_IndividualSoloUna, Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey, Get_Tickets_Credito_Por_Cliente, Factura_Credito_IndividualSoloUna_Prueba } from '../../request/rfc';

const FormatDateUniversal = 'YYYY/MM/DD';
const FormatDateCR = 'DD/MM/YYYY';

export default class Consulta extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            factura: '',
            folioUID: '',
            modalSucursal: '',
            modalFolio: '',
            showModal: false,
            disabled: false,
            fiscalID: this.props.match.params.clienteId,
            clienteNombre: this.props.match.params.clienteNombre,
            fechaInicio: Moment().subtract(7, 'days').format(FormatDateUniversal),
            fechaFinal: Moment().format(FormatDateUniversal),
            selectedRow: {},
            observaciones: '',
            copago: false
        };
        AutoBind(this);
    }

    componentDidMount() {


        this.initTable([]);
        const $table = $(this.refs.tblFacturas);
        $table.on('click-row.bs.table', this.onClickTable);

        const fechaInicio = $(document.getElementById('fechaInicio'));
        const fechaFinal = $(document.getElementById('fechaFinal'));
        const dateOptions = { format: 'dd/mm/yyyy', autoclose: true, language: 'es' };

        fechaInicio.datepicker(dateOptions)
            .on('changeDate', (e) => {
                fechaFinal.datepicker('setStartDate', e.date);
                this.setState({ fechaInicio: Moment(e.date).format(FormatDateUniversal) });
            });
        fechaFinal.datepicker(dateOptions)
            .on('changeDate', (e) => {
                fechaInicio.datepicker('setEndDate', e.date);
                this.setState({ fechaFinal: Moment(e.date).format(FormatDateUniversal) });
            });

        fechaFinal.datepicker('setStartDate', Moment(this.state.fechaInicio).format(FormatDateCR));
        fechaInicio.datepicker('setEndDate', Moment(this.statefechaFinal).format(FormatDateCR));


    }

    componentWillUnmount() {
        // validar lo de las fechas, para destruir el componente
        $(document.getElementById('fechaInicio')).datepicker('destroy');
        $(document.getElementById('fechaFinal')).datepicker('destroy');
    }

    onClickTable(row, $element, field) {
        const selectedRow = document.querySelector('tr.table-info');
        if (!!selectedRow)
            selectedRow.classList.remove('table-info');
        document.querySelector(`tr[data-id="${$element.Factura_Id}"]`).classList.add('table-info');
        this.setState({ selectedRow: $element });
    }

    initTable(data) {

        const $table = $(this.refs.tblFacturas);

        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) { return { 'data-id': row.Factura_Id, 'data-genera': row.Fiscal_NumeroFactura === '' }; },
            columns: [{
                title: 'Factura',
                field: 'Factura_Id',
                sortable: true
            }, {
                title: 'Sucursal',
                field: 'Suc_Id',
                sortable: true
            }, {
                title: 'Caja',
                field: 'Caja_Id',
                sortable: true
            }, {
                title: 'Fecha Transacción',
                field: 'Fecha'
            }, {
                title: 'Total',
                field: 'Total'
            }, {
                title: '# Factura Fiscal',
                field: 'Fiscal_NumeroFactura',
                sortable: true                
                }
                ,
                {
            title: '# Factura Copago',
            field: 'FP_CoPago',
            sortable: true
        }
            ]
        });
    }

    loadTable(data) {
        const $table = $(this.refs.tblFacturas);
        $table.bootstrapTable('load', data || []);
    }


    onSearch() {

        this.cargarFacturas();
    }

    cargarFacturas() {
        const { fiscalID, fechaInicio, fechaFinal } = this.state;
        Get_Tickets_Credito_Por_Cliente({ pClienteId: fiscalID, pFechaInicio: fechaInicio, pFechaFinal: fechaFinal })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const data = Data.map(item => Object.assign({}, item, { Fecha: Moment(item.Fecha).format(FormatDateUniversal), Total: item.Total.toFixed(2) }));
                    this.loadTable(data);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onXML() {
        const { modalSucursal, modalFolio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: modalSucursal, pFolio: modalFolio })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onPDF() {
        const { modalSucursal, folioUID } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: modalSucursal, pFolio: folioUID })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', Data.Nombre);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onCloseModal() {
        this.setState({ showModal: false, disabled: false });
    }

    GenerarFacturaFiscal() {
        this.setState({
            disabled: true
        });
        const { tipoFactura } = this.props.match.params;
        const { selectedRow } = this.state;
        
        console.log(this.state.disabled, 'entr')
        var pcopago = false;
        if (selectedRow.Fiscal_NumeroFactura === '') {
            console.log(this.state.disabled, this.state.showModal, '4444')
            const { cliente, correo, usocfdi } = this.props.match.params;
            const { observaciones } = this.state;
            if (selectedRow.FP_CoPago > 0) {
                pcopago = true;
            }
            const params = {
                pClienteFiscalId: cliente, pCorreo: correo,
                pUsoCFDI: usocfdi, pSucursal: selectedRow.Suc_Id, pCaja: selectedRow.Caja_Id,
                pFactura: selectedRow.Factura_Id, pObservaciones: observaciones, pcopago: pcopago
            };

            Factura_Credito_IndividualSoloUna_Prueba(params)
                .then(this.manageResponseConsulta_Prueba)
                .catch((err) => { console.log(err); this.setState({ disabled: true }); });

            Factura_Credito_IndividualSoloUna(params)
                .then(this.manageResponseConsulta)
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });

            //Factura_Credito_IndividualSoloUna_Prueba(params)
            //    .then(this.manageResponseConsulta_Prueba2)
            //    .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        } else {

            alert('El Ticket ya fue facturado');
        }
        this.setState({
            disabled: false
        });
        this.cargarFacturas()
        console.log(this.state.disabled, 'afuera')

    }


    manageResponseConsulta_Prueba({ data: Response }) {
        const { Message, Data } = Response;
        if (Message !== '') {
            this.setState({
                disabled: true
            });
        } else {
            this.setState({
                disabled: true
            });
        }
    }

    manageResponseConsulta_Prueba2({ data: Response }) {
        const { Message, Data } = Response;
        if (Message !== '') {
            this.setState({
                disabled: false
            });
        } else {
            this.setState({
                disabled: false
            });
        }
    }

    manageResponseConsulta({ data: Response }) {
        const { Message, Data } = Response;
        if (Message !== '') {
            alert(Message);
            this.setState({ disabled: false });
        } else {
            alert('Se generó correctamente la factura.');
            this.setState({
                showModal: true, serie: Data.Serie, modalFolio: Data.NumeroFactura,
                folioUID: Data.UUID, modalSucursal: Data.Suc_Id
            });
        }
    }

    render() {

        const { baseUrl, sucursal, caja, factura, showModal, modalSucursal, modalFolio, disabled, fiscalID, clienteNombre, fechaInicio, fechaFinal, observaciones } = this.state;
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        const cssClassSpin = disabled ? 'fas fa-spinner fa-spin' : 'fas fa-search';

        return (
            <div className="row" id="consulta">
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-12">
                            <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                <i className="fas fa-angle-double-left"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-2">
                            <label>Cliente Id:</label>
                            <input type="text" className="form-control" name="fiscalID" value={fiscalID} onChange={this.onChange} readOnly />
                        </div>
                        <div className="form-group col-md-5">
                            <label>Nombre:</label>
                            <input type="text" className="form-control" name="clienteNombre" value={clienteNombre} onChange={this.onChange} readOnly />
                        </div>
                        <FormGroup col="col-md-2"
                            id="fechaInicio"
                            className="form-control datetime"
                            type="text"
                            name="fechaInicio"
                            label="Fecha Inicio"
                            value={Moment(fechaInicio).format(FormatDateCR)}
                            readOnly={true}
                            disabled={disabled} />

                        <FormGroup col="col-md-2"
                            id="fechaFinal"
                            className="form-control datetime"
                            type="text"
                            name="fechaFinal"
                            label="Fecha Final"
                            value={Moment(fechaFinal).format(FormatDateCR)}
                            readOnly={true}
                            disabled={disabled} />

                        <div className="col-md-1">
                            <button type="button" className="btn btn-custom-theme margin-top-30" disabled={disabled} onClick={this.onSearch}>
                                <i className="fas fa-search"></i>
                            </button>
                        </div>

                        <div className="form-group col-md-8">
                            <label>Observaciones:</label>
                            <input type="text" className="form-control" name="observaciones" value={observaciones} onChange={this.onChange} maxLength="100" />
                        </div>


                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12">
                            <table ref="tblFacturas"></table>
                        </div>
                    </div>
                </div>
                <div id="toolbar">
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.GenerarFacturaFiscal}>
                        <i className={disabled ? 'fas fa-spinner fa-spin' : 'fas fa-clipboard-check'}></i>
                    </button>
                </div>
                <Modal show={showModal}
                    serie={modalSucursal}
                    folio={modalFolio}
                    onXML={this.onXML}
                    onPDF={this.onPDF}
                    onCloseModal={this.onCloseModal}
                />
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/ticket/indexCredito.jsx